import React from "react"
import parse from "html-react-parser"

export const SVG = ({ stateProps, htmlProps }) => {
  let Svg = parse(stateProps.svg.iv || stateProps.svg)
  return React.cloneElement(Svg, htmlProps)
}

export const SVGCanvas = SVG
